export class ClientDto {
  clientName: string;
  clientEmail: string;
  grantTypes: Array<string>;
  scopes: Array<string>;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/client-dto.ts